import CityPageTemplate from "../city-template/CityPageTemplate";
import { manchesterConfig } from "./data";

export default function ManchesterPage() {
  return <CityPageTemplate config={manchesterConfig} />;
}